import { Dispatch, ExtraArgs, GetState } from '../../types'
import { SelectorAction } from '../redux/selector/model'
import { API } from '../../remote-api/models'
import { fetchLoaderHelper } from '../redux/loader/thunksFor'
import { selectResourceFromResources } from '../redux/selector/thunksFor'
import selectorActionCreatorsFor from '../redux/selector/actionCreatorsFor'
import { VERSION_PREFIX, VERSION_RESOURCE_NAME } from './model'
import { isAsset, Resource } from '../resource/model'
import { SelectorOptions } from '../selector/model'

export type VersionAction =
  | SelectorAction<API>

// Basic Actions Creators

export const versionActionCreators = (origin?: string) => {
  return {
    ...selectorActionCreatorsFor<API>(VERSION_RESOURCE_NAME, VERSION_PREFIX, origin)
  }
}

// Thunks

export const fetchVersions = (resource: Resource, origin?: string) => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs): Promise<API[]> => {
  return fetchLoaderHelper<API[]>(dispatch, versionActionCreators(origin), async () => {
    if (isAsset(resource)) {
      return Promise.all(
        resource.apis.map( apiInstance => {
          return api.ui(getState)
              .fetchApi(apiInstance.organizationId, apiInstance.environmentId, apiInstance.id.toString())
              .then(api => ({...api, httpMetrics: apiInstance.httpMetrics}))
              .catch(() => apiInstance)
        })
      )
    } else {
      return []
    }
  })
}

export const selectVersion = (options: SelectorOptions, versions: API[], versionId?: string) =>
  (dispatch: Dispatch): API | undefined => {
    const actionCreators = versionActionCreators(options.origin)

    return dispatch(selectResourceFromResources<API>(
      VERSION_RESOURCE_NAME,
      versions,
      (version: API) => version.id.toString(),
      actionCreators.resourceSelected,
      options.origin,
      options.lsOrigin,
      versionId
    ))
  }

export const storeVersionsAndSelectOne = (version: API, versions: API[], origin?: string) => (dispatch: Dispatch) => {
  const actionCreators = versionActionCreators(origin)
  dispatch(actionCreators.fetchSuccess(versions))
  dispatch(actionCreators.resourceSelected(version))
}
